import * as DashboardType from "../../action/actiontype/DashboardType/Dashboard.jsx";

const dashboardReducer = (state = {}, action) => {
    switch (action.type) {
        case DashboardType.DASHBOARD_REQUEST:
            return {
                ...state,
                dashboardLoading: true,
                dashboardResponse: {},
                dashboardError: null
            }
        case DashboardType.DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboardLoading: false,
                dashboardResponse: action.payload,
                dashboardError: null
            }
        case DashboardType.DASHBOARD_FAILURE:
            return {
                ...state,
                dashboardLoading: false,
                dashboardError: action.payload,
                dashboardResponse: {}
            }
        case DashboardType.DASHBOARDLISTDATA:
            return{
                ...state,
                dashboardList:action.payload

            }
        default:
            return state;
    }
}

export default dashboardReducer;